import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { switchMap, of, map, catchError } from "rxjs";
import { BreeceSelectorState } from "../../models/state/app-state";
import { BreeceSelectorDetails } from "../../services/api-services/system/models/breece-selector-details.model";
import { SystemApiService } from "../../services/api-services/system/system.api-service";
import { BreeceSelectorAction } from "./breece-selector.action";
import { selectBreeceSelector } from "./breece-selector.selectors";



@Injectable()
export class BreeceSelectorEffects {
    actions$: Actions = inject(Actions);
    store: Store = inject(Store);
    api: SystemApiService = inject(SystemApiService);

    fetchBreeceSelectorIfEmpty$ = createEffect(() =>
        this.actions$.pipe(
            ofType(BreeceSelectorAction.getBreeceSelectors), // Trigger this effect when `fetchSomething` action is dispatched
            switchMap(({ enumName, enumLocation }) =>
                this.store.select(selectBreeceSelector(enumName)).pipe(
                    switchMap((selectors) => {
                        // Don't update if it has already been loaded
                        if (selectors)
                            return of();

                        return this.api.getBreeceSelectors(enumName, enumLocation)
                            .pipe(
                                map((selectors: BreeceSelectorDetails[]) =>
                                    BreeceSelectorAction.getBreceSelectorsSuccess({
                                        enumDetails: selectors
                                    })
                                ), catchError((err) =>
                                    of(BreeceSelectorAction.getBreceSelectorsFailed({ error: err }))
                                ))
                    })
                )
            )
        )
    );
}